import { ErrorBase } from '@/errors/ErrorBase';

export class ErrorWithParamBase<T> extends ErrorBase {
    private readonly param: T;
    constructor(param: T, message?: string) {
        super(message);
        this.param = param;
    }

    public getParam() {
        return this.param;
    }
}
